import { Observer } from "mobx-react-lite"
import React from "react"
import { StockSubType } from "../../shared/pagetype"
import { single_quote, quote_item_name } from "../../shared/quotedata/index"
import { store } from "./store"

export function AfterPrice(props: { stocksubtype: StockSubType }) {
  return (
    <Observer>
      {() => (
        <>
          {store.StockDetail && (props.stocksubtype == StockSubType.创业板 || props.stocksubtype == StockSubType.科创板) && (store.StockDetail.f292 == 5 || store.StockDetail.f292 == 19) && (
            <div className="cy-notice">
              <p className="ph-price">
                盘后固定价格:&nbsp;&nbsp;
                {single_quote[quote_item_name.盘后固定价格](store.StockDetail).element}&nbsp;&nbsp;量:&nbsp;&nbsp;
                {single_quote[quote_item_name.盘后量](store.StockDetail).text}&nbsp;&nbsp;额:&nbsp;&nbsp;
                {single_quote[quote_item_name.盘后额](store.StockDetail).text}
              </p>
            </div>
          )}
        </>
      )}
    </Observer>
  )
}
